import $i18n from '../i18n'

const language = {
    state: {
        language: ''
    },
    getters: {
        getLanguage(state) {
            return state.language
        }
    },
    mutations: {
        setLanguage(state, lang) {
            state.language = lang
        }
    },
    actions: {
        loadlLanguage(context) {
            context.commit('setLanguage', $i18n.locale)
        }
    }
}

export default language